// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar {
    z-index: 1;
    width: 15%;
    background: #FFFFFF;
    padding: 10px;
    min-width: fit-content;
    transition: all .4s ease;
}

.collapsed {
    width: 5%;
}

.sideBarItem {
    display: flex;
    gap: 20px;
    height: 48px;
    border-radius: 8px;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    justify-content: center;
}

.sideBarItem span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}


.sideBarItem#active {
    background: #FFF3E8;
}

.sideBarItem#active span {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px
}
.profile_picture>img{
    width:100%;
    height: 100%;
}
.Sidebar_Collapse {
    position: fixed;
    background: #FFFFFF;
    left: 1%;
    bottom: 2%;
    cursor: pointer;
}

.sidebar_content_collapsed{
    display: none;
}

.Sidebar>ul{
    list-style: none;
}

.sideBarItemtitle{
    width: 70%;
}


@media screen and (max-width: 1000px) {

    .Sidebar {
        z-index: 2;
        height: 100vh;
        position: fixed;
        width: 20%;
        background: #FFFFFF;
        padding: 10px;
        min-width: fit-content;
        transition: all .4s ease;
        top: 0;
    }
    .menu {
        display:block;
    }
    .collapse_icon{
        display: none;
    }
    
    .collapsed {
        width: 0 !important;
        padding: 0 !important;
        overflow: hidden;
        transition: all .4s ease;

    }
    
    .sideBarItem {
        display: flex;
        gap: 20px;
        height: 48px;
        border-radius: 8px;
        align-items: center;
        padding: 10px;
        cursor: pointer;
        justify-content: center;
    }
    
    .sideBarItem span {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }
    
    
    .sideBarItem#active {
        background: #FFF3E8;
    }
    
    .sideBarItem#active span {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px
    }
    
    .Sidebar_Collapse {
        position: fixed;
        background: #FFFFFF;
        left: 1%;
        bottom: 2%;
        cursor: pointer;
    }
    
    .sidebar_content_collapsed{
        display: block;
        width: 70%;
    }
    
    .collapsed>ul{
        width: 0 !important;
        overflow: hidden;
        transition: all .4s ease;
    }
    .Sidebar>ul{
        /* width: 100%; */
        list-style: none;
        transition: all .4s ease;
    }
    
    .sideBarItemtitle{
        width: 70%;
    }

}
`, "",{"version":3,"sources":["webpack://./src/CSS/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;;AAGA;;IAEI;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,wBAAwB;QACxB,MAAM;IACV;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,gBAAgB;QAChB,wBAAwB;;IAE5B;;IAEA;QACI,aAAa;QACb,SAAS;QACT,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,QAAQ;QACR,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,UAAU;IACd;;AAEJ","sourcesContent":[".Sidebar {\n    z-index: 1;\n    width: 15%;\n    background: #FFFFFF;\n    padding: 10px;\n    min-width: fit-content;\n    transition: all .4s ease;\n}\n\n.collapsed {\n    width: 5%;\n}\n\n.sideBarItem {\n    display: flex;\n    gap: 20px;\n    height: 48px;\n    border-radius: 8px;\n    align-items: center;\n    padding: 10px;\n    cursor: pointer;\n    justify-content: center;\n}\n\n.sideBarItem span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n\n.sideBarItem#active {\n    background: #FFF3E8;\n}\n\n.sideBarItem#active span {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px\n}\n.profile_picture>img{\n    width:100%;\n    height: 100%;\n}\n.Sidebar_Collapse {\n    position: fixed;\n    background: #FFFFFF;\n    left: 1%;\n    bottom: 2%;\n    cursor: pointer;\n}\n\n.sidebar_content_collapsed{\n    display: none;\n}\n\n.Sidebar>ul{\n    list-style: none;\n}\n\n.sideBarItemtitle{\n    width: 70%;\n}\n\n\n@media screen and (max-width: 1000px) {\n\n    .Sidebar {\n        z-index: 2;\n        height: 100vh;\n        position: fixed;\n        width: 20%;\n        background: #FFFFFF;\n        padding: 10px;\n        min-width: fit-content;\n        transition: all .4s ease;\n        top: 0;\n    }\n    .menu {\n        display:block;\n    }\n    .collapse_icon{\n        display: none;\n    }\n    \n    .collapsed {\n        width: 0 !important;\n        padding: 0 !important;\n        overflow: hidden;\n        transition: all .4s ease;\n\n    }\n    \n    .sideBarItem {\n        display: flex;\n        gap: 20px;\n        height: 48px;\n        border-radius: 8px;\n        align-items: center;\n        padding: 10px;\n        cursor: pointer;\n        justify-content: center;\n    }\n    \n    .sideBarItem span {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n    }\n    \n    \n    .sideBarItem#active {\n        background: #FFF3E8;\n    }\n    \n    .sideBarItem#active span {\n        font-weight: 600;\n        font-size: 14px;\n        line-height: 20px\n    }\n    \n    .Sidebar_Collapse {\n        position: fixed;\n        background: #FFFFFF;\n        left: 1%;\n        bottom: 2%;\n        cursor: pointer;\n    }\n    \n    .sidebar_content_collapsed{\n        display: block;\n        width: 70%;\n    }\n    \n    .collapsed>ul{\n        width: 0 !important;\n        overflow: hidden;\n        transition: all .4s ease;\n    }\n    .Sidebar>ul{\n        /* width: 100%; */\n        list-style: none;\n        transition: all .4s ease;\n    }\n    \n    .sideBarItemtitle{\n        width: 70%;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
